import type { SmartFieldResourceBffReadApi } from '@ingenico/api-sdk-configuration-private';
import type { SmartFieldResourceReadApi } from '@ingenico/api-sdk-configuration-public';
import type {
  FieldSettings,
  MappedSmartFieldBffResourceWithRequiredApi,
  MappedSmartFieldResourceApi,
} from '@ingenico/react-smartfield-utils';
import { mapUiComponentWithRequiredFields, transformDefaultValue } from '@ingenico/react-smartfield-utils';
import { toString } from 'lodash-es';
import {
  formatBooleanValue,
  formatEmptyValue,
  getComponentIsRequired,
  getComponentLabel,
  getSmartFieldDataType,
  getSpecificFieldSettings,
  isLabeledComponent,
  isRequirableComponent,
} from '../utils/smartFieldDetails.util';

function mapDefaultValue(defaultValue: string | undefined): string | undefined {
  if (defaultValue !== undefined && defaultValue !== null) {
    return transformDefaultValue(toString(defaultValue), 10_000);
  }
  return undefined;
}

export function mapSmartFieldBffResourceApi(
  response: SmartFieldResourceBffReadApi,
): MappedSmartFieldBffResourceWithRequiredApi {
  return {
    createdBy: response?.createdBy,
    creationDate: response?.creationDate,
    dataType: response.dataType,
    defaultValue: mapDefaultValue(response.defaultValue),
    description: toString(response.description),
    id: toString(response.id),
    name: toString(response.name),
    categories: response?.categories,
    uiComponent: mapUiComponentWithRequiredFields(response?.uiComponent, 10_000),
    updateDate: response?.updateDate,
    updatedBy: response.updatedBy,
    detailsSection: {
      description: toString(response.description ?? '-'),
      smartFieldId: toString(response.id ?? '-'),
      categories: response?.categories,
      latestModification: response?.updateDate,
      createdBy: toString(response.createdBy?.name ?? '-'),
      creationDate: response?.creationDate,
      parentEntityRef: response?.parentEntityRef,
    },
    fieldSettings: {
      dataType: getSmartFieldDataType(response?.dataType),
      ...(isLabeledComponent(response?.uiComponent?.type) && {
        label: formatEmptyValue(getComponentLabel(response?.uiComponent)),
      }),
      ...(isRequirableComponent(response?.uiComponent?.type) && {
        isRequired: formatBooleanValue(getComponentIsRequired(response?.uiComponent)),
      }),
      ...getSpecificFieldSettings(response?.uiComponent),
    } as unknown as FieldSettings,
  };
}

export function mapBodySmartFieldResourceApi(response: SmartFieldResourceReadApi): MappedSmartFieldResourceApi {
  return {
    creationDate: response?.creationDate,
    dataType: response.dataType,
    defaultValue: mapDefaultValue(response.defaultValue),
    description: toString(response.description),
    id: toString(response.id),
    name: toString(response.name),
    uiComponent: mapUiComponentWithRequiredFields(response?.uiComponent, 10_000),
    updateDate: response?.updateDate,
    detailsSection: {
      description: toString(response.description ?? '-'),
      smartFieldId: toString(response.id ?? '-'),
      categories: response?.categories,
      latestModification: response?.updateDate,
      createdBy: toString(response.createdBy ?? '-'),
      creationDate: response?.creationDate,
    },
    fieldSettings: {
      dataType: getSmartFieldDataType(response?.dataType),
      ...(isLabeledComponent(response?.uiComponent?.type) && {
        label: formatEmptyValue(getComponentLabel(response?.uiComponent)),
      }),
      ...(isRequirableComponent(response?.uiComponent?.type) && {
        isRequired: formatBooleanValue(getComponentIsRequired(response?.uiComponent)),
      }),
      ...getSpecificFieldSettings(response?.uiComponent),
    } as unknown as FieldSettings,
  };
}
